import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useNearContext } from './contexts/NearContext';
import Layout from './components/Layout';
import Home from './components/Home';
import CreateWager from './components/CreateWager';
import WagerDetail from './components/WagerDetail';
import MyWagers from './components/MyWagers';
import LoadingSpinner from './components/LoadingSpinner';

function App() {
  const { loading } = useNearContext();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/create" element={<CreateWager />} />
        <Route path="/wager/:id" element={<WagerDetail />} />
        <Route path="/my-wagers" element={<MyWagers />} />
      </Routes>
    </Layout>
  );
}

export default App;
